import { FC } from 'react';

import { LinkButton, LinkButtonProps } from '@eluve/components';

type OpenInAppButtonProps = {
  appointmentId: string;
  tenantId: string;
  size?: LinkButtonProps['size'];
};

export const OpenInAppButton: FC<OpenInAppButtonProps> = ({
  appointmentId,
  tenantId,
  size,
}) => {
  const url = `/organizations/${tenantId}/appointments/${appointmentId}`;

  return (
    <LinkButton
      icon={{ name: 'AppWindow' }}
      size={size}
      text="Open in App"
      to={url}
      type="outline"
    />
  );
};
